import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Order } from 'models/order';
import { Box, Grid, Typography } from '@mui/material';
import BoxWithHighLighting from 'components/with-hith-light-components/box-with-highlighting.component';
import { Organization } from 'models/organization';
import { Address } from 'models/contact';

type PickUpClinicPostalAddressProps = {
    order: Order;
};
const PickUpClinicPostalAddress: FC<PickUpClinicPostalAddressProps> = ({ order }: PickUpClinicPostalAddressProps) => {
    const { t: translate } = useTranslation(['common', 'organization', 'transport', 'country-names']);
    const [postalAddress, setPostalAddress] = useState<Address>({} as Address);
    const [originalOrderPostalAddress, setOriginalOrderPostalAddress] = useState<Address>({} as Address);
    const [pickUpLocation, setPickUpLocation] = useState<Organization>({} as Organization);
    const [originalOrderPickUpLocation, setOriginalOrderPickUpLocation] = useState<Organization>({} as Organization);
    const [pickUpCountryName, setPickUpCountryName] = useState('');
    const [originalOrderPickUpCountryName, setOriginalOrderPickUpCountryName] = useState('');

    useEffect(() => {
        if (order.deliveryDetails.pickUpLocation.contact.postalAddress) {
            setPostalAddress(order.deliveryDetails.pickUpLocation.contact.postalAddress);
            setOriginalOrderPostalAddress(
                order.originalOrder.deliveryDetails.pickUpLocation.contact.postalAddress || ({} as Address),
            );
        }
        setPickUpLocation(order.deliveryDetails.pickUpLocation);
        setOriginalOrderPickUpLocation(order.originalOrder.deliveryDetails.pickUpLocation);
        setPickUpCountryName(
            translate(`country-names:COUNTRY_${order.deliveryDetails.pickUpLocation.contact?.address?.country || ''}`),
        );
        setOriginalOrderPickUpCountryName(
            translate(
                `country-names:COUNTRY_${order.originalOrder.deliveryDetails.pickUpLocation.contact?.address?.country || ''}`,
            ),
        );
    }, [order]);

    return (
        <Box mb={2}>
            <Box mb={1} display="flex" alignItems="flex-end">
                <Typography variant="h4">{translate('transport:PICK_UP_LOCATION')}</Typography>
            </Box>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2">{translate('common:NAME')}</Typography>
                    <BoxWithHighLighting originalData={originalOrderPickUpLocation.name} data={pickUpLocation.name} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2">{translate('organization:ADDRESS.ADDRESS')}</Typography>
                    <BoxWithHighLighting
                        originalData={
                            originalOrderPostalAddress?.street ||
                            (originalOrderPickUpLocation?.contact?.address?.street as string)
                        }
                        data={postalAddress?.street || (pickUpLocation?.contact?.address?.street as string)}
                    />
                    <Box display="flex">
                        <BoxWithHighLighting
                            sx={{ marginRight: 0.5 }}
                            originalData={
                                originalOrderPostalAddress?.postalCode ||
                                (originalOrderPickUpLocation?.contact?.address?.postalCode as string)
                            }
                            data={postalAddress?.postalCode || (pickUpLocation?.contact?.address?.postalCode as string)}
                        />
                        <BoxWithHighLighting
                            sx={{ marginRight: 0.5 }}
                            originalData={
                                originalOrderPostalAddress?.city ||
                                (originalOrderPickUpLocation?.contact?.address?.city as string)
                            }
                            data={postalAddress?.city || (pickUpLocation?.contact?.address?.city as string)}
                        />
                        <BoxWithHighLighting originalData={originalOrderPickUpCountryName} data={pickUpCountryName} />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default PickUpClinicPostalAddress;
